import { render, staticRenderFns } from "./ResourcesResearchIntro.vue?vue&type=template&id=42abf854&"
import script from "./ResourcesResearchIntro.vue?vue&type=script&lang=js&"
export * from "./ResourcesResearchIntro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports